import { SidebarNavigation } from '@yoast/ui-library';
import cx from 'classnames';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import { getNavigationItems } from './navigationConfig';

interface SharedNavigationContentProps {
  className?: string;
}

const SharedNavigationContent = ({
  className,
}: SharedNavigationContentProps) => {
  const location = useLocation();
  const pathname = location.pathname;

  const navigationItems = getNavigationItems();

  return (
    <div className={cx('yst-flex yst-flex-col yst-gap-10', className)}>
      {/* sidebar nav */}
      <SidebarNavigation.Sidebar>
        <SidebarNavigation.List className="yst-space-y-2">
          {navigationItems
            .filter((item) => item.showInMenu !== false)
            .map((item) => {
              const isActive = item.isActive ? item.isActive(pathname) : false;

              return (
                <SidebarNavigation.SubmenuItem
                  key={item.label}
                  className={cx(`yst-flex yst-gap-x-3`, {
                    'yst-sidebar-navigation__item--active': isActive,
                  })}
                  href={item.href}
                  to={item.href}
                  as={RouterLink}
                  label={
                    <>
                      <item.Icon
                        className={cx`yst-sidebar-navigation__icon yst-h-6 yst-w-6`}
                      />
                      {item.label}
                    </>
                  }
                />
              );
            })}
        </SidebarNavigation.List>
      </SidebarNavigation.Sidebar>
    </div>
  );
};

export default SharedNavigationContent;
